import { Outlet } from '@tanstack/react-router';

/**
 * Layout wrapper for property-scoped settings routes.
 * Child routes handle their own content (property, sharing, transfer).
 */
export const Route = createFileRoute({
	component: () => <Outlet />,
});
